import moment from 'moment-timezone';

import { type Media, type MediaRequest, MediaRequestStatus, MediaType, type Trip } from '@cobliteam/common-types';

import type { MediaRequestData } from '../../types/MediaRequest';
import { getRequestPeriod } from '../../utils/mediaUtils';

export const TIMELAPSE_FINISHED_MESSAGE = 'Já existe um vídeo disponível deste período.';
export const FOOTAGE_FINISHED_MESSAGE = 'Já existe um vídeo disponível deste minuto.';

export const getPeriodErrorMessage = (mediaRequestData?: MediaRequestData, medias?: Media[], trip?: Trip) => {
  const hourErrorMessage = getHourSelectionErrorMessage(mediaRequestData, trip);
  if (hourErrorMessage) {
    return hourErrorMessage;
  }

  const overlapingMedia = getOverlapingMedia(mediaRequestData, medias, trip);
  return getOverlapingMediaErrorMessage(overlapingMedia);
};

const getHourSelectionErrorMessage = (mediaRequestData?: MediaRequestData, trip?: Trip) => {
  if (trip) {
    const selectedPeriod = getRequestPeriod(mediaRequestData, trip);
    const selectedPeriodMoment = moment(selectedPeriod?.start);

    if (!selectedPeriodMoment.isBetween(trip.startTimestamp, trip.endTimestamp, 'minute', '[]')) {
      return 'Insira um horário dentro do período.';
    }
  }

  return undefined;
};

export const getOverlapingMedia = (mediaRequestData?: MediaRequestData, medias?: Media[], trip?: Trip) => {
  if (!medias || !mediaRequestData || !mediaRequestData.requestPeriodStart || !mediaRequestData.requestDate || !mediaRequestData.mediaType) {
    return undefined;
  }

  const selectedPeriod = getRequestPeriod(mediaRequestData, trip);
  const selectedPeriodMoment = moment(selectedPeriod?.start);
  const selectedPeriodTimestamp = selectedPeriodMoment.valueOf();

  return medias.find((m) => m.timestamp === selectedPeriodTimestamp && m.mediaType === mediaRequestData.mediaType);
};

const getOverlapingMediaErrorMessage = (overlapingMedia?: Media): string | undefined => {
  if (!overlapingMedia) {
    return undefined;
  }
  const mediaDetails = overlapingMedia.mediaDetails as MediaRequest;

  if (overlapingMedia.mediaType === MediaType.TIMELAPSE) {
    switch (mediaDetails.status) {
      case MediaRequestStatus.FINISHED:
        return TIMELAPSE_FINISHED_MESSAGE;
      case MediaRequestStatus.PENDING:
        return 'Já existe uma solicitação pendente para esse período.';
      default:
        return undefined;
    }
  }

  // MediaType.FOOTAGE
  switch (mediaDetails.status) {
    case MediaRequestStatus.FINISHED:
      return FOOTAGE_FINISHED_MESSAGE;
    case MediaRequestStatus.PENDING:
      return 'Já existe uma solicitação pendente deste minuto.';
    default:
      return undefined;
  }
};
